import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * SvgPicto
 */

class SvgPicto extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.play = () => {
      this.setState({ isPlaying: true });
      this.element.current.querySelectorAll(`.${this.props.playType}`).forEach((element, index) => {
        setTimeout(() => {
          element.setAttribute('class', `${this.props.playType} ${this.props.color}`);
        }, index * 350);
      });
    };
    this.paused = () => !this.state.isPlaying;

    /** State */
    this.state = { isPlaying: this.props.play };

    /** Refs */
    this.element = React.createRef();
  }

  render() {
    const Svg = this.props.svg;
    return (
      <div ref={this.element} className={`svg-picto l-${this.props.color}`}>
        <Svg />
      </div>
    );
  }
}

SvgPicto.propTypes = {
  svg: PropTypes.elementType.isRequired,
  color: PropTypes.string,
  play: PropTypes.bool,
  playType: PropTypes.oneOf(['w', 'h']),
};

SvgPicto.defaultProps = {
  color: 'primary',
  play: false,
  playType: 'w',
};

export default SvgPicto;
